<template>
  <div class="py-3 px-3 -mx-1 rounded-md bg-gray-300/20 border-l-4 border-grey-400 text-gray-800 dark:bg-gray-700/20 dark:border-gray-500 dark:text-gray-100">
    <h4 class="text-xl font-bold">
      {{ section.name }}
    </h4>
    <p class="text-sm whitespace-pre-line" v-html="section.content" />
  </div>
</template>

<script setup lang="ts">
interface Props {
  section: Record<string, any>
}

defineProps<Props>()
</script>
